import { Button, Row, Col, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { ParagraphHeader } from "@seims/shared";

export default function TermsAndConditions() {

  const navigate = useNavigate();

  return (
    <>
      <Row justify="center" className="page-header" style={{ marginBottom: 10 }}>
        <Col xs={12} md={6} lg={4}>
          <div>
            <Image
              style={{ textAlign: 'center' }}
              src={require("../../../src/assets/t&c.png")}
              alt="User Guides"
              preview={false}
            />
          </div>
        </Col>
      </Row>
      <ParagraphHeader header="Terms and Conditions" />
      <div className="">
        <Row justify="center" className="public-portal-page">
          <Col xs={24}>

          </Col>
          <Col lg={18} md={20} xs={24}>
            <h2 className="left-align"><b>Legal Notice and Disclaimer </b> </h2>
      

            <p>This agreement is between the Department of Science, Technology and Innovation (DSTI) and any person accessing and using this website or those acting through such persons (‘the User’).</p>

            <p>
              Please note that by accessing this website, you are using it entirely at your own risk and are agreeing to be bound by all of the terms and conditions as
              set out herein. In the event that you do not wish to be bound by these terms and conditions, please exit this website as you may not access,
              display, use, download, copy or distribute any of the content of this website. By using this website you, the User, undertake not to use this
              website for any illegal or unlawful purpose and are using a computer system or device that you are authorised to use.
            </p>


            <p>
              The DSTI makes a reasonable effort to keep the contents of this website updated, complete and accurate, but does not warrant or represent that the information is always updated and correct,
              therefore, the onus lies on you to verify any information before use. The DSTI does not warrant that this website is uninterrupted, virus and default free.
              It is the responsibility of the User to ensure that his/her device, hardware and/or software are compatible with this website.
            </p>

            <p>
              Should this website provide a link to another website, the use of such other linked website must not be construed to constitute a relationship with this website’s terms and conditions.
              The use of such links will be at your own risk and liability. In terms of section 15(1) the Merchandise Marks Act, 1941 (Act 17 of 1941) as amended,
              the User or anyone who acts through or via him/her may not use the DSTI logo, brand, trademarks and copyright without an expressed written permission
              of the DSTI.
            </p>

            <p>Should this website provide a link to another website, the use of such other linked website must not be construed to constitute a relationship with this website’s terms and conditions.
              The use of such links will be at your own risk and liability. In terms of section 15(1) the Merchandise Marks Act, 1941 (Act 17 of 1941) as amended,
              the User or anyone who acts through or via him/her may not use the DSTI logo, brand, trademarks and copyright without an expressed written permission of the
              DSTI.
            </p>

            <p>The DSTI reserves the right to modify and update this website at any given time and as such, there may be down-time of the website from time-to-time.</p>

            <p>The DSTI, executive management, employees, sub-contractors, agents, representative or assigns shall not be held liable for any claims (for personal injury, whether direct, indirect,
              consequential or special in any manner whatsoever), losses and damages that may be suffered by the User or his/her employees, sub-contractors, agents,
              representative or assigns that may arise, directly or indirectly, from use or reliance of the contents of this website and its functionality.
            </p>

            <p>By accessing and using this website, you hereby indemnify DSTI, executive management, employees, sub-contractors, agents, representative or assigns against any and all liability for all claims,
              loss, damages made by any third party or incurred by you in respect of any third party that arises from your use of this website.
            </p>

            <p>This website shall be governed by the laws of South Africa. The use of this website constitutes acceptance of these terms and conditions, which contract is then deemed to have been made in Pretoria
              in South Africa.</p>

          </Col>
        </Row>
        <br />
        {/* <Row><Button type="primary" onClick={() => navigate("/")}>Home</Button></Row> */}
      </div>
    </>
  );
}
